import { useEffect, useState } from 'react'
import { axiosInstance } from '../helpers'

export interface UserBanner {
    id: number
    title: string
    message: string
    start_date: string
    expiration_date: string
    created_date: string
}

export const useBannerNotifications = (activeWorkspaceId?: number) => {
    const [banners, setBanners] = useState<UserBanner[]>([])

    useEffect(() => {
        axiosInstance
            .get('notification/banners/')
            .then((res) => setBanners(res.data ?? []))
            .catch(() => {
                /* silently ignore */
            })
    }, [activeWorkspaceId])

    const now = new Date()

    // Filter out client-side expired banners and banners whose start_date hasn't arrived
    const visibleBanners = banners.filter(
        (b) =>
            new Date(b.start_date) <= now && new Date(b.expiration_date) > now,
    )

    // The one expiring soonest
    const activeBanner = visibleBanners.length
        ? visibleBanners.reduce((a, b) =>
              new Date(a.expiration_date) < new Date(b.expiration_date) ? a : b,
          )
        : null

    return { activeBanner }
}
